<template>
  <v-card flat class="glass-background">
    <v-row dense class="justify-start mt-n9 ml-1">
      <v-col dense cols="auto">
        <Headers
          :headersTitle="'Datum/Standort'"
          :headersIcon="'mdi-calendar'"
        />
      </v-col>
    </v-row>

    <v-row dense class="justify-center align-center mt-2 mb-1">
      <v-col dense cols="auto">
        <DateLocationMenu
          v-model:modelValue="dateRange"
          v-model:modelLocation="selectedLocation"
          :dateLocationMenuLocations="dateCardLocations"
        />
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import Headers from '../consumables/Headers.vue'
import DateLocationMenu from './DateLocationMenu.vue'

export default {
  name: 'DateCard',

  components: {
    Headers,
    DateLocationMenu
  },

  props: {
    modelValue: {type: Object, required: true},
    dateCardLocations: {type: Object, default: null},
    modelLocation: {type: String, default: ''}
  },

  emits: ['update:modelValue', 'update:modelLocation'],

  data() {
    return {
      dateRange: {start: '', end: ''},
      selectedLocation: ''
    }
  },

  watch: {
    dateRange: {
      deep: true,
      handler(newVal) {
        this.$emit('update:modelValue', newVal)
      }
    },
    selectedLocation(val) {
      this.$emit('update:modelLocation', val)
    }
  },

  methods: {
    formatDate(dateStr) {
      if (!dateStr) return ''
      const [year, month, day] = dateStr.split('-')
      return `${day}.${month}.${year}`
    },

    parseDate(formatted) {
      const parts = formatted.split('.')
      if (parts.length !== 3) return ''
      const [day, month, year] = parts
      return `${year}-${month}-${day}`
    }
  }
}
</script>

<style scoped>
.v-row, .v-col {
  min-width: 0;
}

.glass-background {
  height: 85%;
  flex-direction: column;
  padding: 1rem;
  background: rgba(var(--v-theme-surface), 0.72);
  backdrop-filter: blur(8px) saturate(120%);
  border: 1px solid rgba(var(--v-theme-surface), 0.35);
  border-radius: 32px;
  overflow: visible;
  overflow-y: visible;
}

.cardNoFavs {
  border-radius: 8px;
  font-size: larger;
  padding-left: 3.35rem;
  padding-right: 3.35rem;
}
</style>
